<template>
    <div class="mt-2">

        <v-container>
            <v-layout row wrap class="justify-space-around">
                <v-flex xs12 sm12 md9 >
                    <v-card class="mx-2">
                        <v-card-text>

                            <div>
                                <h1>La conduite sans permis</h1>
                                <p>
                                    La conduite de tout type de véhicule motorisé requiert de posséder un permis de conduire
                                    en adéquation avec la catégorie du véhicule (voiture, camion, moto…).
                                </p>
                                <p>
                                    Or, en 2017, on estimait qu’au moins 600 000 personnes conduisaient sans permis. (Source
                                    Observatoire National Interministériel de la Sécurité Routière=
                                </p>
                            </div>

                            <div>
                                <h2>Les sanctions encourues pour conduite sans permis</h2>
                                <p>La conduite sans permis constitue un délit qui engendre donc des sanctions pénales.</p>
                            </div>

                            <div>
                                <h2>Les personnes qui ne possèdent pas le permis</h2>
                                <p>
                                    Les personnes qui conduisent sans être titulaires du permis de conduire commettent alors
                                    un délit qui entraîne une amende forfaitaire de 800 euros. Celle-ci peut être minorés à 640
                                    euros en cas de paiement dans un délai de 15 jours. De même, elle peut être majorée à
                                    1 600 euros pour un paiement effectué après un délai de 45 jours.
                                </p>
                                <p>
                                    Cette sanction vise à participer au désengorgement des tribunaux. Elle prend la forme d’un
                                    procès verbal électronique.
                                </p>
                                <p>
                                    Elle s’applique si le conducteur :
                                </p>
                                <ul>
                                    <li>est récidiviste</li>
                                    <li>est mineur</li>
                                    <li>commet un autre délit en même temps</li>
                                </ul>
                            </div>
                            <div>
                                <p>
                                    Conduire avec un permis suspendu, annulé ou invalidé
                                    La loi se fait alors plus sévère. En effet, conduire malgré une suspension, une annulation ou
                                    une invalidation du permis de conduire entraîne une peine d’emprisonnement de 2 ans et
                                    4 500 euros d’amende.
                                </p>
                                <p>
                                    De plus, le permis de conduire peut alors être suspendu pour une durée allant jusqu’à 3 ans.
                                    La suspension en cas d’invalidité peut ne concerner que la conduite hors de l’activité
                                    professionnelle. La suspension en cas d’annulation ou de suspension peut concerner aussi
                                    bien la conduite privée que professionnelle.
                                </p>
                                <p>
                                    Les autres sanctions encourues dans tous les cas de figure
                                </p>
                                <ul>
                                    <li>Si le véhicule appartient au conducteur, il peut être confisqué</li>
                                    <li>Obligation de faire un travail d’intérêt général</li>
                                    <li>Verser des jours-amende au Trésor en remplacement d’un emprisonnement. Le juge
                                        décide du montant (1 000 euros / jour maximum) et de la durée (360 jours
                                        maximum) de ce paiement quotidien au regard des ressources et charges du
                                        contrevenant et des circonstances dans lesquelles l’infraction a été commise.</li>
                                    <li>Ne pas être autorisé à conduire tout type de véhicule terrestre motorisé pendant 5
                                        ans maximum</li>
                                    <li>Suivre, à ses propres frais, un stage de sensibilisation à la sécurité routière</li>
                                </ul>
                            </div>

                            <div>
                                <h2>Conduire malgré une suspension ou une rétention de permis </h2>
                                <p>Ces situations peuvent entraîner : </p>
                                <ul>
                                    <li>Une immobilisation du véhicule</li>
                                    <li>Une réduction du solde maximum de points du permis, passant de 12 à 6 points</li>
                                    <li>Une annulation éventuelle du permis sans pouvoir en demander un autre pendant une période maximale de 3 ans.
                                    </li>
                                </ul>
                                <p>
                                    Certains conducteurs eçoivent de leur avocat une autorisation de conduire une fois le processus de recours
                                    enclenché. Elles n’ont
                                    cependant aucune valeur.
                                </p>
                            </div>

                            <div>
                                <h2>Perdre son permis de conduire </h2>
                                <p>Une perte de permis de conduire est généralement consécutive à la perte de tous les points. En effet, ceci
                                    entraîne une invalidation. De même, la cause peut être des
                                    infractions engendrant la suspension ou l’annulation du permis. </p>
                            </div>

                            <div>

                                <h2>Les infractions et les délits</h2>

                                <p>Il n’est pas possible de perdre 12 points d’un coup. Commettre plusieurs infractions en même temps entraîne le
                                    retrait maximum de 8 points.
                                </p>
                                <p> Les infractions entraînant la perte de 6 points</p>
                                <p>
                                    Certains délits routiers entraînent systématiquement un passage devant le tribunal :</p>
                                <ul>
                                    <li>posséder un avertisseur de radars</li>
                                    <li>excès de vitesse d’au moins 50 km/h</li>
                                    <li>conduire avec un taux d’alcoolémie d’au moins 0,25 mg ou sous l’emprise de stupéfiants </li>
                                </ul>
                                <p>
                                    Commettre l’une de ces infractions en période de permis probatoire entraîne un solde nul et donc une
                                    invalidation du permis.</p>
                                <p>
                                    Les délits à 6 points entraînant une suspension ou une annulation du permis
                                </p>
                                <p>
                                    Un certain nombre d’infractions constituent des délits entraînant un retrait de 6 points et
                                    une suspension ou une annulation du permis ;
                                </p>
                                <ul>
                                    <li>Conduire avec un permis retenu ou invalidé</li>
                                    <li>Refuser de restituer le permis invalidé, annulé ou suspendu</li>
                                    <li>Conduire ou accompagné un élève conducteur avec un taux d’alcoolémie d’au
                                        mois 0,40 mg d’alcool / litre d’air expiré</li>
                                    <li>Refuser de se soumettre aux tests de dépistage des stupéfiants et / ou
                                        d’alcoolémie</li>
                                    <li>Conduire sous l’emprise de stupéfiants</li>
                                    <li>Conduire sous l’emprise d’alcool</li>
                                    <li>Récidive d’un excès de vitesse d’au moins 50 km/h dans un délai de 5 ans après le
                                        premier délit</li>
                                    <li>Refuser d’obtempérer, de se soumettre à des vérifications, d’immobiliser le
                                        véhicule</li>
                                    <li>Commettre un délit de fuite</li>
                                    <li>Gêner la circulation ou l’entraver</li>
                                    <li>Commettre un homicide ou des blessures volontaires entraînant une incapacité
                                        totale de travail</li>
                                    <li>Utiliser volontairement de fausses plaques d’immatriculation ou présenter un
                                        défaut volontaire de plaques ou fausses déclarations</li>
                                </ul>
                            </div>

                            <div>
                                <h2>Les conséquences possibles : permis suspendu, annulé ou invalidé</h2>

                                <h3>Permis de conduire suspendu</h3>
                                <p>
                                    Un permis ne peut pas être suspendu administrativement pendant plus de 6 moins, sauf
                                    pour conduite en état d’ébriété, délit de fuite ou blessures entraînant une incapacité de
                                    travail. En effet, la suspension prend alors un caractère judiciaire et peut durer jusqu’à 6 ans.
                                </p>
                                <p>
                                    Profitez de la période de suspension afin de suivre un stage permettant de récupérer jusqu’à
                                    4 points et évitant que le permis soit invalidé.
                                </p>

                                <h3>Permis de conduire annulé</h3>
                                <p>
                                    Le permis de conduire est annulé automatiquement en cas de :
                                </p>
                                <ul>
                                    <li>conduite en état d’ébriété provoquant des blessures graves ou le décès de la victime,</li>
                                    <li>récidive de conduite en état d’ivresse,</li>
                                    <li>récidive de conduite sous l’emprise de stupéfiants,</li>
                                    <li>récidive de refus de se soumettre au contrôle du taux d’alcoolémie.</li>
                                </ul>
                                <p>
                                    L’annulation est prononcée par un juge en cas de très graves infractions comme conduire en
                                    état d’ivresse ou malgré une suspension de permis, refuser de rendre un permis suspendu,
                                    refuser de se soumettre à un test d’alcoolémie ou commettre un délit de fuite.
                                </p>

                                <h3>Permis de conduire invalidé</h3>
                                <p>
                                    La perte totale des points du permis déclenche l’envoi de la lettre recommandée 48SI
                                    stipulant l’invalidation du permis. Celui-ci doit être restitué à ma Préfecture dans les 10
                                    jours. L’invalidation prend effet avec le récépissé de l’accusé de réception.
                                </p>
                                <p>
                                    Il faut attendre 6 mois avant de pouvoir obtenir un nouveau permis, sous réserve de
                                    résultats positifs à la visite médicale et aux tests psychotechnique (aux frais du conducteur).
                                </p>
                                <p>
                                    Un nouveau retrait de point suite à l’obtention du nouveau permis dans une période de 5
                                    ans entraîne une attente d’1 an avant une nouvelle demande.
                                </p>
                            </div>

                            <div>
                                <h2>Comment ne pas perdre son permis</h2>
                                <p>Il suffit d’opter pour un comportement responsable :</p>
                                <ul>
                                    <li>Consultez votre solde de points sur Télépoints à réception de tout courrier
                                        envoyé par la Préfecture signifiant un retrait de points.</li>
                                    <li>Suivez un stage de récupération de points dès que votre solde atteint les 6 points.
                                        Vous récupérerez ainsi 4 points à son issue et éviterez de vous retrouver dans une
                                        situation extrême.</li>
                                    <li>Ne conduisez jamais sans permis. Préférez repasser votre permis de conduire</li>
                                    <li>Sur la route, faites preuve de vigilance et évitez de vous mettre, ainsi que les
                                        autres usagers de la route, en situation de danger.</li>
                                </ul>
                            </div>
                        </v-card-text>
                    </v-card>

                </v-flex>
                <v-flex xs12 sm12 md3>
                    <v-card class="mx-2">
                        <v-card-text>
                            <RightAsideInfractions></RightAsideInfractions>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <Footer />
    </div>
</template>

<script>
    import RightAsideInfractions from '@/components/RightAsideInfractions'
    import Footer from '@/components/Footer'

    export default {
        name: "stage-recuperation-points",
        components: {
            RightAsideInfractions,
            Footer
        }
    }
</script>

<style>
    .highlighted {
        background: #ffedf5;
        border-radius: 10px;
        color: #7a0439;
        font-size: 18px;
        font-weight: 800;
        padding: 10px;
    }

    .highlighted p {
        font-size: 18px;
    }

    ul li {
        list-style-type: circle;
        margin: 10px 0 10px 0;
    }

    a {
        text-decoration: none;
    }

    a:hover {
        color: black;
    }

    p {
        font-size: 16px;
    }
</style>
